export default function CtaBand() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20wide%20scene%20with%20deep%20terracotta%20and%20warm%20golden%20light%20streaks%2C%20soft%20textured%20backdrop%20with%20gentle%20shadow%2C%20artistic%20film%20grain%2C%20elegant%20moody%20atmosphere%2C%20no%20people%2C%20editorial%20composition&width=1920&height=760&seq=ssl-cta-band&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/55 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
            还没理清结局？从最关键的一步开始
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-100/85 max-w-xl">
            先看结局解析，再回看人物关系与剧情梳理，你会发现那些当时觉得「什么都没发生」的镜头，其实都在说话。
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <a
            href="#ending"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm md:text-base font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-book-marked-line"></i> 阅读结局解析
          </a>
          <a
            href="#story"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm md:text-base font-medium whitespace-nowrap bg-background-50/10 text-background-50 border border-background-50/30 hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            <i className="ri-list-ordered"></i> 查看剧情梳理
          </a>
        </div>
      </div>
    </section>
  );
}